import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b5ed89e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header-container" }
const _hoisted_2 = { class: "title-dialog" }
const _hoisted_3 = { class: "form-container mt-3" }
const _hoisted_4 = { class: "button-group flex justify-between w-full px-4" }

import { ref, reactive, watch } from 'vue';
import { getPaginatedCompanyForDropDown } from '@/_services/company/company';
import { CompanyWhitelist } from '@/models/securite/whitelist/IcompanyWhiteLis';
interface Props {
    header: string;
    visible: boolean;
    selectedMethod: string;
    tableData: CompanyWhitelist[];
    isSubmitting: boolean
}
const validateIpAddressError = 'Veuillez entrer une adresse IP valide.';

export default /*#__PURE__*/_defineComponent({
  __name: 'WhiteListModal',
  props: {
    header: {},
    visible: { type: Boolean },
    selectedMethod: {},
    tableData: {},
    isSubmitting: { type: Boolean }
  },
  emits: ['confirm', 'update:visible', 'update:selected-method'],
  setup(__props: any, { emit }) {

const props = __props;



const localSelectedMethod = ref(props.selectedMethod);
function validateIpAddress (node) {
    const value = node.value;
    const regex = new RegExp(`^\\d+(\\.\\d+)+$`);
    return regex.test(value);
}
const formData = reactive({
    IP: {
        address: '',
        company: '',
        description: '',
        requestedBy: ''
    },
    Company: {
        companyName: '',
        description: '',
        requestedBy: ''
    },
    Email: {
        email: '',
        description: '',
        requestedBy: ''
    }
});
const validateCompanyNotInList = (node) => {
    const isInCompany =  props.tableData.some(item => {
        return item.company.uuid === node.value;
    });

    return !isInCompany
};
const submitForm = async () => {
    const data = formData[localSelectedMethod.value];
    if (!validateFormData(data)) {
        return;
    }
    try {
        emit('confirm', data);
    } catch (error) {
        console.error('Error during form submission:', error);
    } finally {
        //props.isSubmitting = false; 
    }
};


const validateFormData = (data: any) => {
    let isValid = true;
    for (const key in data) {
        if (data[key] === '') {
            isValid = false;
        }
    }
    return isValid;
};

const closeDialog = () => {
    emit('update:visible', false);
    resetFormData();
};

const resetFormData = () => {
    formData.IP.address = '';
    formData.IP.company = '';
    formData.IP.description = '';
    formData.IP.requestedBy = '';
    formData.Company.companyName = '';
    formData.Company.description = '';
    formData.Company.requestedBy = '';
    formData.Email.email = '';
    formData.Email.description = '';
    formData.Email.requestedBy = '';
};

watch(() => props.visible, (newVal) => {
    if (!newVal) {
        resetFormData();
    }
});

watch(localSelectedMethod, (newVal) => {
    emit('update:selected-method', newVal);
});

async function searchSupplierOptions({ search, page, hasNextPage }) {
    const [totalCompaniesRecordsForDropDown, companiesForDropDown] = await getPaginatedCompanyForDropDown(5, page, search, true);

    const hasItems = companiesForDropDown.length > 0;
    if (hasItems && page !== totalCompaniesRecordsForDropDown) {
        hasNextPage();
    }

    return companiesForDropDown;
}

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    header: _ctx.header,
    visible: _ctx.visible,
    class: "dialog-container custom-dialog",
    modal: "",
    style: { width: '30rem' },
    closable: false
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.header), 1)
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_FormKit, {
          modelValue: localSelectedMethod.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((localSelectedMethod).value = $event)),
          type: "select",
          id: "methodSelect",
          options: [
                    { value: 'IP', label: 'Par IP' },
                    { value: 'Company', label: 'Par société' },
                    { value: 'Email', label: 'Par email' }
                  ]
        }, null, 8, ["modelValue"]),
        _createVNode(_component_FormKit, {
          type: "form",
          id: "supplierForm",
          onSubmit: submitForm,
          actions: false,
          "incomplete-message": "Désolé, tous les champs ne sont pas remplis correctement."
        }, {
          default: _withCtx(({ state: { valid } }) => [
            (localSelectedMethod.value === 'IP')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(['form-field', {'invalid-field': !formData.IP.address}])
                  }, [
                    _createVNode(_component_FormKit, {
                      type: "text",
                      name: "ipAddress",
                      label: "Adresse IP*",
                      modelValue: formData.IP.address,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.IP.address) = $event)),
                      "validation-rules": { validateIpAddress: validateIpAddress },
                      validation: "required|validateIpAddress",
                      "validation-messages": {
                                  required: 'Veuillez entrer une adresse IP.',
                                  validateIpAddress: validateIpAddressError,
                                }
                    }, null, 8, ["modelValue", "validation-rules", "validation-messages"])
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(['form-field', {'invalid-field': !formData.IP.company}])
                  }, [
                    _createVNode(_component_FormKit, {
                      type: "autocomplete",
                      label: "Société*",
                      name: "company",
                      placeholder: "Sélectionner une société",
                      options: searchSupplierOptions,
                      modelValue: formData.IP.company,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.IP.company) = $event)),
                      validation: "required",
                      "validation-messages": { required: 'Veuillez sélectionner une société.' }
                    }, null, 8, ["modelValue", "validation-messages"])
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(['form-field', {'invalid-field': !formData.IP.requestedBy}])
                  }, [
                    _createVNode(_component_FormKit, {
                      type: "text",
                      modelValue: formData.IP.requestedBy,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.IP.requestedBy) = $event)),
                      label: "Personne qui fait la demande*",
                      validation: "required",
                      "validation-messages": { required: 'Veuillez entrer la personne qui fait la demande.' }
                    }, null, 8, ["modelValue", "validation-messages"])
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(['form-field', {'invalid-field': !formData.IP.description}])
                  }, [
                    _createVNode(_component_FormKit, {
                      type: "textarea",
                      modelValue: formData.IP.description,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.IP.description) = $event)),
                      label: "Description*",
                      validation: "required|length:0,255",
                      "validation-messages": { 
                                required: 'Veuillez entrer une description.',
                                length: 'Ce champ doit contenir maximum 255 caractères.',
                            }
                    }, null, 8, ["modelValue", "validation-messages"])
                  ], 2)
                ], 64))
              : _createCommentVNode("", true),
            (localSelectedMethod.value === 'Company')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(['form-field', {'invalid-field': !formData.Company.companyName }])
                  }, [
                    _createVNode(_component_FormKit, {
                      type: "autocomplete",
                      label: "Nom de la société*",
                      name: "company",
                      placeholder: "Sélectionner une société",
                      options: searchSupplierOptions,
                      modelValue: formData.Company.companyName,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.Company.companyName) = $event)),
                      validation: "required|validateCompanyNotInList",
                      "validation-rules": {validateCompanyNotInList: validateCompanyNotInList},
                      "validation-messages": { 
                                    required: 'Veuillez sélectionner une société.',
                                    validateCompanyNotInList: 'Cette société existe déjà.'
                                }
                    }, null, 8, ["modelValue", "validation-rules", "validation-messages"])
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(['form-field', {'invalid-field': !formData.Company.requestedBy}])
                  }, [
                    _createVNode(_component_FormKit, {
                      type: "text",
                      modelValue: formData.Company.requestedBy,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.Company.requestedBy) = $event)),
                      label: "Personne qui fait la demande*",
                      validation: "required",
                      "validation-messages": { required: 'Veuillez entrer la personne qui fait la demande.' }
                    }, null, 8, ["modelValue", "validation-messages"])
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(['form-field', {'invalid-field': !formData.Company.description}])
                  }, [
                    _createVNode(_component_FormKit, {
                      type: "textarea",
                      modelValue: formData.Company.description,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.Company.description) = $event)),
                      label: "Description*",
                      validation: "required|length:0,255",
                      "validation-messages": { 
                                required: 'Veuillez entrer une description.',
                                length: 'Ce champ doit contenir maximum 255 caractères.',
                            }
                    }, null, 8, ["modelValue", "validation-messages"])
                  ], 2)
                ], 64))
              : _createCommentVNode("", true),
            (localSelectedMethod.value === 'Email')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(['form-field', {'invalid-field': !formData.Email.email}])
                  }, [
                    _createVNode(_component_FormKit, {
                      type: "email",
                      modelValue: formData.Email.email,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formData.Email.email) = $event)),
                      label: "Email*",
                      validation: "required|email",
                      "validation-messages": {
                                required: 'Veuillez entrer un email.',
                                email: 'Veuillez entrer un email valide.'
                            }
                    }, null, 8, ["modelValue", "validation-messages"])
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(['form-field', {'invalid-field': !formData.Email.requestedBy}])
                  }, [
                    _createVNode(_component_FormKit, {
                      type: "text",
                      modelValue: formData.Email.requestedBy,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formData.Email.requestedBy) = $event)),
                      label: "Personne qui fait la demande*",
                      validation: "required",
                      "validation-messages": { required: 'Veuillez entrer la personne qui fait la demande.' }
                    }, null, 8, ["modelValue", "validation-messages"])
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(['form-field', {'invalid-field': !formData.Email.description}])
                  }, [
                    _createVNode(_component_FormKit, {
                      type: "textarea",
                      modelValue: formData.Email.description,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formData.Email.description) = $event)),
                      label: "Description*",
                      validation: "required|length:0,255",
                      "validation-messages": { 
                                required: 'Veuillez entrer une description.',
                                length: 'Ce champ doit contenir maximum 255 caractères.',
                            }
                    }, null, 8, ["modelValue", "validation-messages"])
                  ], 2)
                ], 64))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_Button, {
                type: "submit",
                label: "Ajouter",
                class: "mr-3 flex-grow bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
              }),
              _createVNode(_component_Button, {
                type: "button",
                label: "Retour",
                class: "p-button-danger",
                onClick: closeDialog
              })
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["header", "visible"]))
}
}

})